import { useState } from "react";
import { resolveEffectiveMagnitude } from "../utils/newPrefixMagnitude";
/**
 * Block size of a new publisher prefix, limited by the backend {@code maxMagnitude} and {@code allowedMagnitudes}. The selection is
 * derived: until the user picks a size (or when the picked one is no longer allowed) the smallest allowed
 * size is used, so the value is always one the backend accepts.
 */
export var useNewPrefixMagnitude = function (maxMagnitude, allowedMagnitudes) {
    var _a = useState(null), selected = _a[0], setSelected = _a[1];
    return {
        magnitude: resolveEffectiveMagnitude(selected, maxMagnitude, allowedMagnitudes),
        setMagnitude: setSelected,
    };
};
